import { distributionChannels } from '@raisin/cp-utils';

export const getDistributionChannelId = (locale: string): string =>
  distributionChannels[locale] || distributionChannels['en-US'];
